/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PageMembersWithTeamValidation } from '../../models/page-members-with-team-validation';

export interface GetAllMembersApiV2SecretariatMembersAllGet$Params {
  name?: (string | null);
  excludeDeleted?: boolean;
  censorData?: boolean;
  org: string;

/**
 * Page number
 */
  page?: number;

/**
 * Page size
 */
  size?: number;
}

export function getAllMembersApiV2SecretariatMembersAllGet(http: HttpClient, rootUrl: string, params: GetAllMembersApiV2SecretariatMembersAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PageMembersWithTeamValidation>> {
  const rb = new RequestBuilder(rootUrl, getAllMembersApiV2SecretariatMembersAllGet.PATH, 'get');
  if (params) {
    rb.query('name', params.name, {});
    rb.query('excludeDeleted', params.excludeDeleted, {});
    rb.query('censorData', params.censorData, {});
    rb.query('org', params.org, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageMembersWithTeamValidation>;
    })
  );
}

getAllMembersApiV2SecretariatMembersAllGet.PATH = '/api/v2/secretariat/members/all';
